import { useState } from 'react'
import $ from 'jquery'
import Swal from 'sweetalert2'
import { SlUser } from 'react-icons/sl'
import { HiOutlinePhone } from 'react-icons/hi'
import { MdOutlineMailOutline } from 'react-icons/md'
import { LuMailQuestion } from 'react-icons/lu'
import { HiOutlineBuildingLibrary } from "react-icons/hi2";

function CA_form_page() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    mobileNo: '',
    collegeName: '',
  })

  const [nameError, setNameError] = useState(' ')
  const [emailError, setEmailError] = useState('')
  const [phoneError, setPhoneError] = useState('')
  const [collegeError, setCollegeError] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target

    if (name === 'fullName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setNameError(`Invalid name format.`)
      } else {
        setNameError('')
      }
    }

    if (name === 'email') {
      if (!value || !/\S+@\S+\.\S+/.test(value)) {
        setEmailError('Invalid email format')
      } else {
        setEmailError('')
      }
    }

    if (name === 'mobileNo') {
      if (!value || !/^\d{10}$/.test(value)) {
        setPhoneError('Length Should be 10 Digit')
      } else {
        setPhoneError('')
      }
    }
    if (name === 'collegeName') {
      if (!value || !/^[A-Za-z\s]+$/.test(value)) {
        setCollegeError(`Invalid College Name format.`)
      } else {
        setCollegeError('')
      }
    }
    setFormData({
      ...formData,
      [name]: value,
    })
  }

  const handleSubmit = async (event) => {
    event.preventDefault()

    var fullNameElements = $('[name="fullName"]')
    var mobileNoElements = $('[name="mobileNo"]')
    var emailElements = $('[name="email"]')
    var collegeNameElements = $('[name="collegeName"]')

    var fullName = ''
    var mobileNo = ''
    var email = ''
    var collegeName = ''

    // Function to collect non-empty values from elements
    function getNonEmptyValue(elements) {
      var value = ''
      elements.each(function () {
        if ($(this).val().trim() !== '') {
          value = $(this).val()
          return false // Exit loop if non-empty value found
        }
      })
      return value
    }

    // Collect non-empty values for each field
    fullName = getNonEmptyValue(fullNameElements)
    mobileNo = getNonEmptyValue(mobileNoElements)
    email = getNonEmptyValue(emailElements)
    collegeName = getNonEmptyValue(collegeNameElements)

    $.ajax({
      url: 'https://forms.internselite.net/CAForm',
      type: 'POST',
      data: {
        fullName: fullName,
        mobileNo: mobileNo,
        email: email,
        collegeName: collegeName,
      },
      success: function (response) {
        console.log(
          formData.fullName,
          $('[name="fullName"]').val(),
          $('[name="mobileNo"]').val(),
          $('[name="email"]').val(),
        )
        Swal.fire({
          title: 'Form Submitted!',
          text:
            "Thank you for applying to be a Campus Ambassador! Your application has been received, and we're thrilled to have you on board soon.",
          icon: 'success',
        })
        $('[name="collegeName"]').val('')
        $('[name="fullName"]').val('')
        $('[name="mobileNo"]').val('')
        $('[name="email"]').val('')
      },
      error: function (error) {
        console.error('Error:', error)
      },
    })
  }

  return (
    <div>
      <div className="BDA_form_text shadow-lg px-4 py-4 mt-3">
        <div className="text-center">
          <span className="border-bottom pb-3">Apply Now...</span>
        </div>
        <div className="pt-3">
          <form onSubmit={handleSubmit}>
            <div class="mt-3">
              <label for="fullName" class="pb-2 px-2 contact_form">
                <SlUser size="20px" color="#565add" /> Full Name
              </label>
              <input
                className="form-control"
                type="text"
                id="fullName"
                name="fullName"
                placeholder="Your answer"
                value={formData.fullName}
                onChange={handleInputChange}
                required
              />
              {nameError && (
                <div className="error text-danger">{nameError}</div>
              )}
            </div>
            <div class="mt-3">
              <label for="email" class="pb-2 px-2 contact_form">
                <MdOutlineMailOutline size="20px" color="#565add" /> Email
                Address
              </label>
              <input
                className="form-control"
                type="email"
                id="email"
                name="email"
                placeholder="Your answer"
                value={formData.email}
                onChange={handleInputChange}
                required
              />
              {emailError && (
                <div className="error text-danger">{emailError}</div>
              )}
            </div>
            <div class="mt-3">
              <label for="mobileNo" class="pb-2 px-2 contact_form">
                <HiOutlinePhone size="20px" color="#565add" /> Phone Number
              </label>
              <input
                className="form-control"
                type="tel"
                id="mobileNo"
                name="mobileNo"
                placeholder="+91 xxxxxxxxxx"
                value={formData.mobileNo}
                onChange={handleInputChange}
                required
              />
              {phoneError && (
                <div className="error text-danger">{phoneError}</div>
              )}
            </div>
            <div class="my-3">
              <label for="collegeName" class="pb-2 px-2 contact_form ">
                <HiOutlineBuildingLibrary size="20px" color="#565add" /> College Name
              </label>
              <input
                className="form-control"
                type="text"
                id="collegeName"
                name="collegeName"
                placeholder="Your answer"
                value={formData.collegeName}
                onChange={handleInputChange}
                required
              />
              {collegeError && (
                <div className="error text-danger">{collegeError}</div>
              )}
            </div>
            <div className="row mt-2 pt-4">
              <div className="d-flex justify-content-center">
                <button
                  onClick={handleSubmit}
                  className="shadow-sm mx-4 px-5 pt-2 pb-2 Contact_button"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default CA_form_page
